// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as HarnessActions from '@fc-store/actions/harness.actions';
import { Harness } from '@fc-core';

export const harnessFeatureKey = 'harness';

export interface State {
  harnessSearch: Harness[];
  harnessList: Harness[];
}

export const initialState: State = {
  harnessSearch: null,
  harnessList: null,
};

export const reducer = createReducer(
  initialState,

  on(HarnessActions.searchHarness, (state) => state),
  on(HarnessActions.searchHarnessSuccess, (state, action) => ({
    ...state,
    harnessSearch: action.data,
  })),
  on(HarnessActions.searchHarnessFailure, (state) => state),
  on(HarnessActions.getAllHarnessSuccess, (state, action) => ({
    ...state,
    harnessList: action.data,
  })),
);

export const getHarnessList = (state: State) => state.harnessList;
